import BetslipButtonControllerImpl from './betslip-button-controller.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * BetslipButton module.
 *
 * @class BetslipButtonController
 * @name module
 * @extends Mojito.Core.Presentation.UIViewImplementation
 * @memberof Mojito.Modules.BetslipButton
 */

/**
 * BetslipButtonController prop types.
 *
 * @property {Function} [onClick = () => {}] - Callback function executes on betslip button click.
 * @property {boolean} [disabled = false] - Flag controlling the button's disabled state. A disabled button is not clickable and has additional styles applied to it.
 * @property {boolean} [showImage = false] - Flag controlling if button should render image.
 * @property {boolean} [enableFreebetsIndication] - Flag to control if free bet indication should be shown on betslip button.
 * @property {boolean} [isQuickBetslip = false] - Indication if quick betslip is showing.
 *
 * @memberof Mojito.Modules.BetslipButton.module
 */

const propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    showImage: PropTypes.bool,
    enableFreebetsIndication: PropTypes.bool,
    isQuickBetslip: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const defaultProps = {
    onClick: noop,
    disabled: false,
    showImage: false,
    isQuickBetslip: false,
};

export default UIControllerView(
    'BetslipButtonController',
    BetslipButtonControllerImpl,
    propTypes,
    defaultProps
);
